// Presentation routing only, not a device-control permission or capability list.
// Keep the control page's direct switches; every other type uses its native
// panel, including the existing unsupported-device fallback. Never rewrite IDs
// or product codes to make another product's panel appear supported.
export function deviceControlEntry(productCode) {
  return ['01', '021', '05', '048'].includes(productCode) ? 'switch' : 'popup';
}
